import { createNamespace } from './base'

const send = createNamespace( '/api/question' )

const QuestionApi = {
    GetQuestionWithDoctorAnswer: ( {doctor_id, answer_id, lang = "ru"} ) => send({ action: 'question-with-doctor-answer', data: { doctor_id, answer_id, lang } }),
}

export default QuestionApi